import { InAppState, initialInAppState } from './in-app.reducers';
import { InAppBundleState, initialInAppBundleState } from './in-app-bundle.reducers';
import { EmailState, initialEmailState } from './email.reducers';
import { State } from '../editor.reducers';
import { EditorActions } from '../editor.actions';
import { LocaleActionTypes } from '../actions/locale.actions';
import { InAppActionTypes } from '../actions/in-app.actions';
import { InAppBundleActionTypes } from '../actions/in-app-bundle.actions';
import { EmailActionTypes } from '../actions/email.actions';
import { DEFAULT_LOCALE } from '../locales';

export interface LocaleState {
  inApp: InAppState;
  inAppBundle: InAppBundleState;
  email: EmailState;
}

export function initialLocaleState(): LocaleState {
  return {
    inApp: initialInAppState(),
    inAppBundle: initialInAppBundleState(),
    email: initialEmailState(),
  };
}

export function localeReducer(nextState: State, action: EditorActions): State {
  switch (action.type) {
    case LocaleActionTypes.ADD_LOCALE:
      if (action.payload.locale in nextState.locales) {
        break;
      }
      if (!(DEFAULT_LOCALE in nextState.locales)) {
        nextState.locales[DEFAULT_LOCALE] = initialLocaleState();
        break;
      }
      nextState.locales[action.payload.locale] = initialLocaleState();
      if (!(nextState.general.selectedLocale in nextState.locales)) {
        break;
      }
      nextState.locales[action.payload.locale].inApp.contentTemplate =
        nextState.locales[nextState.general.selectedLocale].inApp.contentTemplate;
      nextState.locales[action.payload.locale].inApp.contentTemplateError =
        nextState.locales[nextState.general.selectedLocale].inApp.contentTemplateError;
      nextState.locales[action.payload.locale].inApp.linkTemplate =
        nextState.locales[nextState.general.selectedLocale].inApp.linkTemplate;
      nextState.locales[action.payload.locale].inApp.linkTemplateError =
        nextState.locales[nextState.general.selectedLocale].inApp.linkTemplateError;
      nextState.locales[action.payload.locale].inApp.renderedHTML =
        nextState.locales[nextState.general.selectedLocale].inApp.renderedHTML;
      nextState.locales[action.payload.locale].inApp.renderedHTMLError =
        nextState.locales[nextState.general.selectedLocale].inApp.renderedHTMLError;
      nextState.locales[action.payload.locale].inAppBundle.contentTemplate =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.contentTemplate;
      nextState.locales[action.payload.locale].inAppBundle.contentTemplateError =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.contentTemplateError;
      nextState.locales[action.payload.locale].inAppBundle.linkTemplate =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.linkTemplate;
      nextState.locales[action.payload.locale].inAppBundle.linkTemplateError =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.linkTemplateError;
      nextState.locales[action.payload.locale].inAppBundle.renderedHTML =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.renderedHTML;
      nextState.locales[action.payload.locale].inAppBundle.renderedHTMLError =
        nextState.locales[nextState.general.selectedLocale].inAppBundle.renderedHTMLError;
      nextState.locales[action.payload.locale].email.contentTemplate =
        nextState.locales[nextState.general.selectedLocale].email.contentTemplate;
      nextState.locales[action.payload.locale].email.contentTemplateError =
        nextState.locales[nextState.general.selectedLocale].email.contentTemplateError;
      nextState.locales[action.payload.locale].email.linkTemplate =
        nextState.locales[nextState.general.selectedLocale].email.linkTemplate;
      nextState.locales[action.payload.locale].email.linkTemplateError =
        nextState.locales[nextState.general.selectedLocale].email.linkTemplateError;
      nextState.locales[action.payload.locale].email.subjectTemplate =
        nextState.locales[nextState.general.selectedLocale].email.subjectTemplate;
      nextState.locales[action.payload.locale].email.subjectTemplateError =
        nextState.locales[nextState.general.selectedLocale].email.subjectTemplateError;
      nextState.locales[action.payload.locale].email.fromNameTemplate =
        nextState.locales[nextState.general.selectedLocale].email.fromNameTemplate;
      nextState.locales[action.payload.locale].email.fromNameTemplateError =
        nextState.locales[nextState.general.selectedLocale].email.fromNameTemplateError;
      nextState.locales[action.payload.locale].email.fromAddressTemplate =
        nextState.locales[nextState.general.selectedLocale].email.fromAddressTemplate;
      nextState.locales[action.payload.locale].email.fromAddressTemplateError =
        nextState.locales[nextState.general.selectedLocale].email.fromAddressTemplateError;
      nextState.locales[action.payload.locale].email.renderedHTML =
        nextState.locales[nextState.general.selectedLocale].email.renderedHTML;
      nextState.locales[action.payload.locale].email.renderedHTMLError =
        nextState.locales[nextState.general.selectedLocale].email.renderedHTMLError;
      break;
    case LocaleActionTypes.SET_LOCALES:
      nextState.locales[DEFAULT_LOCALE] = initialLocaleState();
      action.payload.locales.forEach((locale) => {
        nextState.locales[locale] = initialLocaleState();
      });
      break;
    case LocaleActionTypes.SELECTED_LOCALE_CHANGED: {
      const localeState = nextState.locales[action.payload.locale];
      if (!localeState) {
        break;
      }
      nextState.inApp.contentTemplate = localeState.inApp.contentTemplate;
      nextState.inApp.contentTemplateError = localeState.inApp.contentTemplateError;
      nextState.inApp.linkTemplate = localeState.inApp.linkTemplate;
      nextState.inApp.linkTemplateError = localeState.inApp.linkTemplateError;
      nextState.inApp.renderedHTML = localeState.inApp.renderedHTML;
      nextState.inApp.renderedHTMLError = localeState.inApp.renderedHTMLError;
      nextState.inAppBundle.contentTemplate = localeState.inAppBundle.contentTemplate;
      nextState.inAppBundle.contentTemplateError = localeState.inAppBundle.contentTemplateError;
      nextState.inAppBundle.linkTemplate = localeState.inAppBundle.linkTemplate;
      nextState.inAppBundle.linkTemplateError = localeState.inAppBundle.linkTemplateError;
      nextState.inAppBundle.renderedHTML = localeState.inAppBundle.renderedHTML;
      nextState.inAppBundle.renderedHTMLError = localeState.inAppBundle.renderedHTMLError;
      nextState.email.contentTemplate = localeState.email.contentTemplate;
      nextState.email.contentTemplateError = localeState.email.contentTemplateError;
      nextState.email.linkTemplate = localeState.email.linkTemplate;
      nextState.email.linkTemplateError = localeState.email.linkTemplateError;
      nextState.email.subjectTemplate = localeState.email.subjectTemplate;
      nextState.email.subjectTemplateError = localeState.email.subjectTemplateError;
      nextState.email.fromNameTemplate = localeState.email.fromNameTemplate;
      nextState.email.fromNameTemplateError = localeState.email.fromNameTemplateError;
      nextState.email.fromAddressTemplate = localeState.email.fromAddressTemplate;
      nextState.email.fromAddressTemplateError = localeState.email.fromAddressTemplateError;
      nextState.email.renderedHTML = localeState.email.renderedHTML;
      nextState.email.renderedHTMLError = localeState.email.renderedHTMLError;
      break;
    }
    case InAppActionTypes.LOAD_IN_APP_CONTENT_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.contentTemplate = action.payload.template;
      break;
    case InAppActionTypes.LOAD_IN_APP_CONTENT_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.contentTemplateError = action.payload.error;
      break;
    case InAppActionTypes.LOAD_IN_APP_LINK_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.linkTemplate = action.payload.template;
      break;
    case InAppActionTypes.LOAD_IN_APP_LINK_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.linkTemplateError = action.payload.error;
      break;
    case InAppBundleActionTypes.LOAD_IN_APP_BUNDLE_CONTENT_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.contentTemplate = action.payload.template;
      break;
    case InAppBundleActionTypes.LOAD_IN_APP_BUNDLE_CONTENT_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.contentTemplateError =
        action.payload.error;
      break;
    case InAppBundleActionTypes.LOAD_IN_APP_BUNDLE_LINK_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.linkTemplate = action.payload.template;
      break;
    case InAppBundleActionTypes.LOAD_IN_APP_BUNDLE_LINK_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.linkTemplateError = action.payload.error;
      break;
    case EmailActionTypes.LOAD_EMAIL_CONTENT_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.contentTemplate = action.payload.template;
      break;
    case EmailActionTypes.LOAD_EMAIL_CONTENT_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.contentTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.contentTemplateError = action.payload.error;
      break;
    case EmailActionTypes.LOAD_EMAIL_LINK_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.linkTemplate = action.payload.template;
      break;
    case EmailActionTypes.LOAD_EMAIL_LINK_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.linkTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.linkTemplateError = action.payload.error;
      break;
    case EmailActionTypes.LOAD_EMAIL_SUBJECT_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.subjectTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.subjectTemplate = action.payload.template;
      break;
    case EmailActionTypes.LOAD_EMAIL_SUBJECT_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.subjectTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.subjectTemplateError = action.payload.error;
      break;
    case EmailActionTypes.LOAD_EMAIL_FROM_ADDRESS_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromAddressTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromAddressTemplate = action.payload.template;
      break;
    case EmailActionTypes.LOAD_EMAIL_FROM_ADDRESS_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromAddressTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromAddressTemplateError = action.payload.error;
      break;
    case EmailActionTypes.LOAD_EMAIL_FROM_NAME_TEMPLATE_SUCCESS:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromNameTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromNameTemplate = action.payload.template;
      break;
    case EmailActionTypes.LOAD_EMAIL_FROM_NAME_TEMPLATE_ERROR:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromNameTemplateLoading = false;
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromNameTemplateError = action.payload.error;
      break;
    case InAppActionTypes.SET_IN_APP_TEMPLATE_CONTENT:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.contentTemplate = action.payload.content;
      break;
    case InAppActionTypes.SET_IN_APP_TEMPLATE_LINK:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inApp.linkTemplate = action.payload.link;
      break;
    case InAppBundleActionTypes.SET_IN_APP_BUNDLE_TEMPLATE_CONTENT:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.contentTemplate = action.payload.content;
      break;
    case InAppBundleActionTypes.SET_IN_APP_BUNDLE_TEMPLATE_LINK:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].inAppBundle.linkTemplate = action.payload.link;
      break;
    case EmailActionTypes.SET_EMAIL_CONTENT_TEMPLATE:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.contentTemplate = action.payload.template;
      break;
    case EmailActionTypes.SET_EMAIL_LINK_TEMPLATE:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.linkTemplate = action.payload.template;
      break;
    case EmailActionTypes.SET_EMAIL_SUBJECT_TEMPLATE:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.subjectTemplate = action.payload.template;
      break;
    case EmailActionTypes.SET_EMAIL_FROM_NAME_TEMPLATE:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromNameTemplate = action.payload.template;
      break;
    case EmailActionTypes.SET_EMAIL_FROM_ADDRESS_TEMPLATE:
      nextState.locales[action.payload.locale || DEFAULT_LOCALE].email.fromAddressTemplate = action.payload.template;
      break;
  }
  return nextState;
}
